import { v4 as uuidv4 } from 'uuid';

import { DialogContextRef, ConfirmDialogConfig, ToastDialogConfig } from './types';

let dialogContextRef: DialogContextRef | null = null;

export const dialogManager = {
  openConfirmDialog: (config: ConfirmDialogConfig) => {
    if (!dialogContextRef) {
      console.warn('DialogProvider not mounted. Dialog will not open.');

      return {
        id: '',
        close: () => {},
        update: () => {},
        setConfirmLoading: () => {},
        setCancelLoading: () => {},
      };
    }

    const id = config.id || uuidv4();

    return dialogContextRef.openConfirmDialog({ ...config, id });
  },

  openToastDialog: (config: ToastDialogConfig) => {
    if (!dialogContextRef) {
      console.warn('DialogProvider not mounted. Dialog will not open.');

      return {
        id: '',
        close: () => {},
        update: () => {},
      };
    }

    const id = config.id || uuidv4();

    return dialogContextRef.openToastDialog({ ...config, id });
  },

  closeDialog: (id: string): void => {
    if (!dialogContextRef) {
      console.warn('DialogProvider not mounted.');
      return;
    }
    dialogContextRef.closeDialog(id);
  },

  closeAllDialogs: (): void => {
    if (!dialogContextRef) {
      console.warn('DialogProvider not mounted.');
      return;
    }
    dialogContextRef.closeAllDialogs();
  },

  updateDialog: (id: string, config: Partial<ConfirmDialogConfig | ToastDialogConfig>): void => {
    if (!dialogContextRef) {
      console.warn('DialogProvider not mounted.');
      return;
    }
    dialogContextRef.updateDialog(id, config);
  },
};

// Registration functions for the provider
export const registerDialogContext = (ref: DialogContextRef): void => {
  dialogContextRef = ref;
};

export const unregisterDialogContext = (): void => {
  dialogContextRef = null;
};
